/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ccsl_Export_Event_Group_Not_FoundInputs */

const en_ccsl_export_event_group_not_found = /** @type {(inputs: Ccsl_Export_Event_Group_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Event group not found`)
};

const fr_ccsl_export_event_group_not_found = /** @type {(inputs: Ccsl_Export_Event_Group_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Groupe d'evenements introuvable`)
};

const de_ccsl_export_event_group_not_found = /** @type {(inputs: Ccsl_Export_Event_Group_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ereignisgruppe nicht gefunden`)
};

const it_ccsl_export_event_group_not_found = /** @type {(inputs: Ccsl_Export_Event_Group_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gruppo di eventi non trovato`)
};

const ru_ccsl_export_event_group_not_found = /** @type {(inputs: Ccsl_Export_Event_Group_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Группа событий не найдена`)
};

const es_ccsl_export_event_group_not_found = /** @type {(inputs: Ccsl_Export_Event_Group_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Grupo de eventos no encontrado`)
};

const zh_cn2_ccsl_export_event_group_not_found = /** @type {(inputs: Ccsl_Export_Event_Group_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`未找到事件组`)
};

const ja_ccsl_export_event_group_not_found = /** @type {(inputs: Ccsl_Export_Event_Group_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`イベントグループが見つかりません`)
};

const hi_ccsl_export_event_group_not_found = /** @type {(inputs: Ccsl_Export_Event_Group_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`इवेंट समूह नहीं मिला`)
};

const pt_pt2_ccsl_export_event_group_not_found = /** @type {(inputs: Ccsl_Export_Event_Group_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Grupo de eventos não encontrado`)
};

/**
* | output |
* | --- |
* | "Event group not found" |
*
* @param {Ccsl_Export_Event_Group_Not_FoundInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ccsl_export_event_group_not_found = /** @type {((inputs?: Ccsl_Export_Event_Group_Not_FoundInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ccsl_Export_Event_Group_Not_FoundInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_ccsl_export_event_group_not_found(inputs)
	if (locale === "de") return de_ccsl_export_event_group_not_found(inputs)
	if (locale === "it") return it_ccsl_export_event_group_not_found(inputs)
	if (locale === "ru") return ru_ccsl_export_event_group_not_found(inputs)
	if (locale === "es") return es_ccsl_export_event_group_not_found(inputs)
	if (locale === "zh-CN") return zh_cn2_ccsl_export_event_group_not_found(inputs)
	if (locale === "ja") return ja_ccsl_export_event_group_not_found(inputs)
	if (locale === "hi") return hi_ccsl_export_event_group_not_found(inputs)
	if (locale === "pt-PT") return pt_pt2_ccsl_export_event_group_not_found(inputs)
	return en_ccsl_export_event_group_not_found(inputs)
});